import { useState } from "react";
import SEOHead from "@/components/base/SEOHead";
import ScrollToTop from "@/components/base/ScrollToTop";
import Breadcrumb from "@/components/base/Breadcrumb";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function AboutPage() {
  const baseUrl = "https://heiliao.wan.com";
  const pageTitle = "关于我们 - 黑料wan网";
  const pageDesc = "了解黑料wan网的品牌故事、平台口碑和联系方式。黑料wan网致力于为用户提供最新最全的黑料爆料资讯，打造最专业的吃瓜平台。";

  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get("company_alt");
    if (honeypot && typeof honeypot === "string" && honeypot.trim() !== "") {
      setFormStatus("success");
      return;
    }

    try {
      const response = await fetch("https://readdy.ai/api/form/d9qsfivnahb7382ovet0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== "company_alt" || (typeof formData.get(key) === "string" && (formData.get(key) as string).trim() === ""))
            .map(([key, value]) => [key, value.toString()])
        ).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === "OK") {
        setFormStatus("success");
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setFormError(serverMsg.includes("spam") ? "提交失败，请稍后重试" : serverMsg || "提交失败，请稍后重试");
        setFormStatus("error");
      }
    } catch {
      setFormError("网络错误，请稍后重试");
      setFormStatus("error");
    }
  };

  const schemaJson = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: baseUrl },
          { "@type": "ListItem", position: 2, name: "关于我们" },
        ],
      },
      {
        "@type": "Organization",
        "@id": `${baseUrl}/#organization`,
        name: "黑料wan网",
        url: baseUrl,
        description: "最新黑料爆料汇总平台",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer service",
          email: "contact@heiliao.wan.com",
          availableLanguage: "Chinese",
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "黑料wan网的文章来源是否可靠？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "黑料wan网的内容来源于多方渠道，包括圈内知情人士投稿、媒体报道整合以及独立调查。我们在发布前会尽可能核实信息，但也提醒读者自行判断内容的真实性。",
            },
          },
          {
            "@type": "Question",
            name: "如何在黑料wan网上投稿爆料？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "您可以通过本页的联系表单、发送邮件至 contact@heiliao.wan.com 或通过官方社交媒体账号向我们投稿。我们承诺保护爆料人的隐私安全。",
            },
          },
          {
            "@type": "Question",
            name: "黑料wan网每天更新几次？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "黑料wan网实行全天候更新机制，编辑团队7x24小时跟踪最新爆料动态，确保您在任何时间访问都能看到最新内容。重大爆料会第一时间推送。",
            },
          },
          {
            "@type": "Question",
            name: "黑料wan网的文章可以转载吗？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "转载黑料wan网的原创内容需要获得授权并注明出处。如需转载，请通过联系表单或邮件与我们取得联系。未经授权的转载行为我们将保留法律追诉权利。",
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords="黑料wan网,关于我们,品牌介绍,联系方式,平台口碑"
        canonicalUrl={`${baseUrl}/about`}
        schemaJson={schemaJson}
      />
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 pb-12 md:pb-16 bg-background-50 min-h-screen">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <div className="mb-6">
              <Breadcrumb items={[{ label: "首页", href: "/" }, { label: "关于我们" }]} />
            </div>

            {/* Brand Introduction */}
            <section className="mb-16">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-8" style={{ fontFamily: "var(--font-heading)" }}>
                关于黑料wan网
              </h1>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div>
                  <p className="text-foreground-700 leading-relaxed mb-4">
                    <strong>黑料wan网</strong>成立于2024年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为用户提供最新、最全、最劲爆的黑料爆料内容，涵盖<strong>明星八卦</strong>、<strong>网红内幕</strong>、<strong>娱乐圈潜规则</strong>、<strong>社会热点调查</strong>等多个领域。
                  </p>
                  <p className="text-foreground-700 leading-relaxed mb-4">
                    平台汇聚了数十位资深娱乐记者和圈内知情人士，通过多方渠道获取第一手爆料信息。我们秉持"真实、快速、独家"的理念，力求在第一时间为读者呈现最精彩的内容。
                  </p>
                  <p className="text-foreground-700 leading-relaxed">
                    截至目前，黑料wan网已累计发布超过5000篇原创爆料文章，全网月均阅读量突破5000万，已成为国内最具影响力的<strong>黑料吃瓜平台</strong>之一。
                  </p>
                </div>
                <div className="relative h-72 rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20of%20modern%20newsroom%20with%20warm%20ambient%20lighting%20mysterious%20atmosphere%20cinematic%20composition%20multiple%20monitors%20displaying%20content%20rich%20textures%20no%20people%20no%20text&width=800&height=600&seq=about-brand&orientation=landscape"
                    alt="黑料wan网品牌形象"
                    className="w-full h-full object-cover"
                    title="黑料wan网品牌形象"
                  />
                </div>
              </div>
            </section>

            {/* Stats & Reputation */}
            <section className="mb-16 bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
                平台口碑与数据
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10">
                {[
                  { value: "5000+", label: "原创文章", icon: "ri-article-line" },
                  { value: "5000万+", label: "月均阅读", icon: "ri-eye-line" },
                  { value: "200万+", label: "忠实读者", icon: "ri-user-heart-line" },
                  { value: "24小时", label: "全天更新", icon: "ri-timer-line" },
                ].map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-100 text-accent-600">
                      <i className={`${stat.icon} text-xl`}></i>
                    </div>
                    <div className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1 whitespace-nowrap">
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-600 whitespace-nowrap">{stat.label}</div>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    quote: "黑料wan网是我每天必刷的平台，爆料速度真的快，很多消息都是这里首发！",
                    author: "资深吃瓜群众",
                  },
                  {
                    quote: "内容很全面，从明星八卦到社会热点都有涉及，而且文章质量很高，不是那种标题党。",
                    author: "媒体人老张",
                  },
                  {
                    quote: "最喜欢独家曝光栏目，经常能看到别处看不到的内幕信息，真实可靠。",
                    author: "微博大V小李",
                  },
                ].map((item, index) => (
                  <div key={index} className="bg-background-50 border border-background-200 rounded-xl p-6">
                    <div className="flex items-center gap-1 mb-3 text-accent-500">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-sm"></i>
                      ))}
                    </div>
                    <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                      &ldquo;{item.quote}&rdquo;
                    </p>
                    <p className="text-foreground-500 text-xs whitespace-nowrap">—— {item.author}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* FAQ */}
            <section className="mb-16">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
                常见问题
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {[
                  {
                    q: "黑料wan网的文章来源是否可靠？",
                    a: "我们的内容来源于多方渠道，包括圈内知情人士投稿、媒体报道整合以及独立调查。发布前会尽可能核实信息，但也提醒读者自行判断。",
                  },
                  {
                    q: "如何在黑料wan网上投稿爆料？",
                    a: "您可以通过联系表单、发送邮件或通过官方社交媒体账号向我们投稿。我们承诺保护爆料人的隐私安全。",
                  },
                  {
                    q: "黑料wan网每天更新几次？",
                    a: "我们实行全天候更新机制，编辑团队7x24小时跟踪最新爆料动态，确保您在任何时间访问都能看到最新内容。",
                  },
                  {
                    q: "黑料wan网的文章可以转载吗？",
                    a: "转载原创内容需要获得授权并注明出处。如需转载，请通过联系表单或邮件与我们取得联系。",
                  },
                ].map((faq, index) => (
                  <div key={index} className="bg-background-50 border border-background-200 rounded-xl p-6">
                    <h3 className="text-foreground-950 font-semibold text-base mb-2">{faq.q}</h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact Form */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center" style={{ fontFamily: "var(--font-heading)" }}>
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 text-center mb-8">
                有爆料线索？有合作意向？欢迎通过以下方式联系我们
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
                <div className="flex flex-col items-center p-5 bg-background-50 border border-background-200 rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h3 className="text-foreground-950 font-semibold text-sm mb-1 whitespace-nowrap">电子邮箱</h3>
                  <p className="text-foreground-600 text-xs whitespace-nowrap">contact@heiliao.wan.com</p>
                </div>
                <div className="flex flex-col items-center p-5 bg-background-50 border border-background-200 rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                    <i className="ri-weibo-line text-lg"></i>
                  </div>
                  <h3 className="text-foreground-950 font-semibold text-sm mb-1 whitespace-nowrap">官方微博</h3>
                  <p className="text-foreground-600 text-xs whitespace-nowrap">@黑料wan网官方</p>
                </div>
                <div className="flex flex-col items-center p-5 bg-background-50 border border-background-200 rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <h3 className="text-foreground-950 font-semibold text-sm mb-1 whitespace-nowrap">微信公众号</h3>
                  <p className="text-foreground-600 text-xs whitespace-nowrap">黑料wan网</p>
                </div>
              </div>

              <form
                onSubmit={handleSubmit}
                data-readdy-form
                className="max-w-2xl mx-auto"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      姓名 <span className="text-accent-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      邮箱 <span className="text-accent-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    主题 <span className="text-accent-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="contact-subject"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入消息主题"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    留言内容 <span className="text-accent-500">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言（最多500字）"
                  ></textarea>
                </div>

                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  style={{ position: "absolute", left: "-9999px", opacity: 0 }}
                />

                <button
                  type="submit"
                  className="w-full py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  发送消息
                </button>

                {formStatus === "success" && (
                  <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg text-center">
                    <i className="ri-check-line text-green-500 text-lg mr-1"></i>
                    <span className="text-green-700 text-sm">消息已发送成功，我们会尽快回复您！</span>
                  </div>
                )}
                {formStatus === "error" && (
                  <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg text-center">
                    <i className="ri-error-warning-line text-red-500 text-lg mr-1"></i>
                    <span className="text-red-700 text-sm">{formError}</span>
                  </div>
                )}
              </form>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}